// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    name: 'dev',
    production: true,
    VERSION: require('../../package.json').version,
    base_url:"https://api.dev.scrubupapp.com.au/",
    main_url:"https://app.dev.scrubupapp.com.au/",
};




// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/environments/environment.ts